export default "__VITE_ASSET__CoHA31Yn__"